import React from "react";
import { Check, Sparkles, ArrowRight } from "lucide-react";
import { PRICING } from "../data/mock";
import Reveal from "./Reveal";

export default function Pricing() {
  return (
    <section className="section" id="pricing">
      <div className="container-x">
        <Reveal>
          <div className="text-center mb-12">
            <div
              className="font-script"
              style={{ fontSize: 22, color: "var(--agero-orange)" }}
            >
              (Engagements)
            </div>
            <h2
              className="font-display mt-3"
              style={{
                fontSize: "clamp(40px, 6vw, 92px)",
                letterSpacing: "-0.05em",
                lineHeight: 0.98,
              }}
            >
              Two ways to work with us.
            </h2>
            <p
              className="mt-6 text-neutral-600 text-[17px] leading-relaxed mx-auto"
              style={{ maxWidth: 620 }}
            >
              Month-to-month. No contracts. We keep clients because the numbers
              work. Pricing is tailored to your stage and goals. Book a call to
              see if we&apos;re a fit.
            </p>
          </div>
        </Reveal>

        <div className="grid lg:grid-cols-2 gap-6">
          {PRICING.map((p, i) => {
            const isAccent = p.accent;
            return (
              <Reveal key={i} delay={i * 140} y={36}>
              <div
                key={i}
                className={`rounded-[32px] p-8 md:p-10 relative overflow-hidden flex flex-col ${
                  isAccent ? "text-white" : "text-neutral-900"
                }`}
                style={{
                  background: isAccent
                    ? "linear-gradient(160deg, #ff3301 0%, #d62a00 60%, #a32000 100%)"
                    : "#fff",
                  minHeight: 560,
                }}
              >
                {p.badge && (
                  <span
                    className="absolute top-6 right-6 px-3 py-1 rounded-full text-[11px] font-semibold tracking-wider"
                    style={{
                      background: "rgba(0,0,0,0.25)",
                      color: "#fff",
                    }}
                  >
                    {p.badge}
                  </span>
                )}

                <div className="flex items-center gap-3">
                  <div
                    className="w-10 h-10 rounded-xl flex items-center justify-center"
                    style={{
                      background: isAccent ? "rgba(255,255,255,0.2)" : "#0A0A0A",
                      color: "#fff",
                    }}
                  >
                    <Sparkles size={18} />
                  </div>
                  <div className="font-semibold text-[15px] tracking-wider uppercase">
                    {p.plan}
                  </div>
                </div>

                <p
                  className={`mt-6 text-[16px] leading-relaxed ${
                    isAccent ? "text-white/90" : "text-neutral-600"
                  }`}
                  style={{ maxWidth: 380 }}
                >
                  {p.description}
                </p>

                <div className="mt-8">
                  <div
                    className={`${
                      isAccent ? "text-white/80" : "text-neutral-500"
                    } text-sm`}
                  >
                    {p.delivery}
                  </div>
                </div>

                {/* Custom pricing block (price hidden) */}
                <div
                  className="mt-5 inline-flex items-center gap-2 px-4 py-2 rounded-full self-start"
                  style={{
                    background: isAccent
                      ? "rgba(255,255,255,0.16)"
                      : "rgba(255, 51, 1, 0.08)",
                    color: isAccent ? "#fff" : "var(--agero-orange)",
                  }}
                >
                  <span
                    className="w-1.5 h-1.5 rounded-full"
                    style={{
                      background: isAccent ? "#fff" : "var(--agero-orange)",
                    }}
                  />
                  <span className="text-[13px] font-semibold tracking-wide">
                    Tailored to your stage
                  </span>
                </div>

                <div className="mt-6 flex flex-col gap-3 flex-1">
                  {p.features.map((f, j) => (
                    <div key={j} className="flex items-start gap-3">
                      <span
                        className="w-6 h-6 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5"
                        style={{
                          background: isAccent
                            ? "rgba(255,255,255,0.25)"
                            : "#0A0A0A",
                          color: "#fff",
                        }}
                      >
                        <Check size={14} />
                      </span>
                      <span
                        className={
                          isAccent ? "text-white/95" : "text-neutral-800"
                        }
                      >
                        {f}
                      </span>
                    </div>
                  ))}
                </div>

                <a
                  href="#booking"
                  className="mt-8 inline-flex items-center justify-center gap-2 px-6 py-3.5 rounded-full font-medium transition w-full sm:w-auto self-start"
                  style={{
                    background: isAccent ? "#fff" : "#0A0A0A",
                    color: isAccent ? "#0A0A0A" : "#fff",
                  }}
                >
                  Book a Call to See if We&apos;re a Fit
                  <ArrowRight size={16} />
                </a>
              </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}
